import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

// Arrays para los filtros activos
let activeCollections = [];
let activeVariantAttributes = [];
export class ModWebSearchCollection extends ModuleComponent {

    ready() {
        super.ready();

        const parentCollectionId = this.$root.data("parent-collection");

        const collectionButton = document.querySelector(this.scope + "__filter-collection");
        const variantButtons = document.querySelectorAll(this.scope + "__filter-variant");

        const collectionContainer = document.getElementById("collection-container");
        const variantContainer = document.getElementById("variant-container");

        function resetCollection() {
            collectionContainer.style.display = "none";
            collectionButton.classList.remove("active");
        }

        function resetVariant() {
            if (variantContainer){
                const variantItems = variantContainer.querySelectorAll(`[data-variant-type]`);
                variantButtons.forEach(button => {
                    button.classList.remove("active");
                });
                variantItems.forEach(item => {
                    item.style.display = "none";
                });
            }
        }

        function addActiveFilter(filterType, filterId) {
            switch (filterType) {
                case "collection":
                    if (!activeCollections.includes(filterId)) {
                        activeCollections.push(filterId);
                    }
                    break;
                case "variant":
                    if (!activeVariantAttributes.includes(filterId)) {
                        activeVariantAttributes.push(filterId);
                    }
                    break;
            }
            updateFilters();
        }

        function removeActiveFilter(filterType, filterId) {
            switch (filterType) {
                case "collection":
                    activeCollections = activeCollections.filter(id => id !== filterId);
                    break;
                case "variant":
                    activeVariantAttributes = activeVariantAttributes.filter(id => id !== filterId);
                    break;
            }
            updateFilters();
        }

        function toggleActive(button, container) {
            if (container.style.display === "flex") {
                resetCollection();
                if (variantContainer) {
                    resetVariant();
                }
            } else {
                resetCollection();
                if (variantContainer) {
                    resetVariant();
                }
                button.classList.add("active");
                container.style.display = "flex";
            }
            syncActiveClasses();
        }

        collectionButton.addEventListener("click", function () {
            toggleActive(collectionButton, collectionContainer);
        });

        const collectionItems = document.querySelectorAll(this.scope+"__filter-collections");
        collectionItems.forEach(item => {
            item.addEventListener("click", function () {
                const filterId = item.getAttribute('data-collection');
                addActiveFilter("collection", filterId);
            });
        });

        const variantItems = document.querySelectorAll(this.scope+"__filter-variant-attrs");
        variantItems.forEach(item => {
            item.addEventListener("click", function () {
                const filterId = item.getAttribute('data-variant');
                addActiveFilter("variant", filterId);
            });
        });

        // Evento para los botones de variantes
        variantButtons.forEach(button => {
            button.addEventListener("click", function () {
                const selectedId = button.getAttribute("data-type");
                const variantItems = variantContainer.querySelectorAll(`[data-variant-type]`);

                resetCollection();
                resetVariant();

                button.classList.add("active");
                syncActiveClasses();

                variantItems.forEach(item => {
                    const variantTypeId = item.getAttribute("data-variant-type");
                    if (variantTypeId === selectedId) {
                        item.style.display = "flex";
                    }
                });

            });
        });

        const inactiveFilterButtons = document.querySelectorAll(this.scope + "__inactive-filter");
        inactiveFilterButtons.forEach(button => {
            button.addEventListener("click", handleRemoveActiveFilter);
        });

        function handleRemoveActiveFilter(event) {
            const element = event.target;
            const collectionId = element.getAttribute('data-collection');
            const variantId = element.getAttribute('data-variant');

            if (collectionId) {
                const collectionItem = document.querySelector(`[data-collection="${collectionId}"]`);
                if (collectionItem) collectionItem.classList.remove("active");
                removeActiveFilter("collection", collectionId);
            } else if (variantId) {
                const variantItem = document.querySelector(`[data-variant="${variantId}"]`);
                if (variantItem) variantItem.classList.remove("active");
                removeActiveFilter("variant", variantId);
            }
        }

        function updateFilters() {
            GvfService.endpoint('/web/web-collection/filter-web-product-by-collection', {
                parentCollectionId:parentCollectionId,
                webCollectionIds: activeCollections,
                variantAttributeIds: activeVariantAttributes
            }).then((resp) => {
                if (resp.html) {
                    const contentDiv = document.getElementById('collection');
                    contentDiv.innerHTML = resp.html;
                    GvfUiService.init($(resp.html));
                    activeCollections = resp.webCollectionIds;
                    activeVariantAttributes = resp.variantAttributeIds;
                }
            });
        }

        function syncActiveClasses() {
            collectionItems.forEach(item => {
                const filterId = item.getAttribute('data-collection');
                if (activeCollections.includes(filterId)) {
                    item.classList.add("active");
                }
            });

            variantItems.forEach(item => {
                const filterId = item.getAttribute('data-variant');
                if (activeVariantAttributes.includes(filterId)) {
                    item.classList.add("active");
                }
            });

        }
    }

}